import { closest } from './domClosest'

/**
 * チェックボックスを単一選択にする
 */
export class FormCheckSingle {

	/**
	 * 指定した要素の中のチェックボックスを単一選択にする
	 * @param {Element} container
	 */
	constructor (container) {
		/** @var {Element} */
		this.el = container

		/** @var {function} */
		this._changeHandler = (event) => {
			this.onChange(event)
		}

		this.activate()
	}

	activate () {
		this.el.addEventListener('change', this._changeHandler)
	}

	deactivate () {
		this.el.removeEventListener('change', this._changeHandler)
	}

	/**
	 * @param {Event} event
	 */
	onChange (event) {
		/** @var {HTMLInputElement} */
		const checkbox = closest('input[type="checkbox"]', event.target)
		if (!checkbox || !checkbox.checked) return

		/** @var {NodeList<HTMLInputElement>} */
		const audiences = this.el.querySelectorAll('input[type="checkbox"]')
		;[].forEach.call(audiences, audience => {
			if (audience === checkbox) return
			audience.checked = false
		})
	}
}

export function register (selector) {
	[].forEach.call(document.querySelectorAll(selector), el => new FormCheckSingle(el))
}
